import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { changeDomain } from 'src/common/utils/url-utils';
import { validate } from 'uuid';
import { useCurrentSpaceDomain } from '../space';

/** 根据pageId自动切换空间 */
export const useAutoChangeDomain = () => {
  const history = useHistory();
  const domain = useCurrentSpaceDomain();

  useEffect(() => {
    const uuid = location.pathname.slice(-36);
    if (!validate(uuid)) return;
    const newPathname = changeDomain(domain ?? '', location);
    if (newPathname && newPathname !== location.pathname) {
      history.replace(`${newPathname}${location.search}${location.hash}`);
    }
  }, [domain, history]);
};
